import React from "react";

const description = () => {
  return (
    <div className="intro">
      Submit your Pitch Planet videos & tell your story to investors, community members & ecosystem partners who want to
      be inspired by your company, products, investment opportunities & more.
    </div>
  );
};

export default description;
